import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Button, Box } from '@mui/material';
import createToast from 'components/Toast/Toast';
import useCustomHook from '../hooks';
import {
    PageContainer,
    FilterPod,
    TableComponents,
    SimpleDialog,
    ButtonLoading,
} from 'components';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { columns, generateData } from './components/Columns';
import { useStyles } from './style';
import {
    serviceSet,
    publishServiceSetApi,
    unPublishServiceSetApi,
    exportServiceSetApi,
} from '../services/ServiceSetServices';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';

const ListServiceSets = () => {
    //-- STATES --//
    let tableRef = useRef();
    const {
        loading,
        setLoading,
        setFilterParams,
        size,
        setSize,
        page, setPage,
        filters,
        setFilters,
        dialogContent,
        setDialogContent,
        selectedRow,
        setSelectedRow,
        requestAction,
        setRequestAction,
        loadingBtn,
        setLoadingBtn,
        loadingBtnDialog,
        setLoadingBtnDialog,
        openDialog,
        setOpenDialog,
    } = useCustomHook();

    const actionsList =
        getDynamicObjectAction([
            'subMyWebServiceListPage',
            'exportSubMyWebServiceListPage',
            'editSubMyWebServiceListPage',
        ])
    const closeDialog = () => {
        setOpenDialog(false);
    };
    const [openFilterDialog, setOpenFilterDialog] = useState(false);
    const handleCloseFilterDialog = () => setOpenFilterDialog(false);

    //--HOOKS--//
    const classes = useStyles();
    const navigate = useNavigate();

    //--API REQUESTS--//
    const getServiceSetsList = async (query) => {
        try {
            setLoading(true);
            let filter = toFilterVOS([...filters]);
            let queries = filterVOStoQueryStr(filter);

            let params = {
                offset: query ? query?.pageNumber * query?.pageSize : page * size,
                size: query?.pageSize || size,
                ...queries,
            };

            const data = {
                filterVOS: [],
                parentParams: [],
                orderByElementVOS: [],
            };

            setFilterParams({ data, params });

            const res = await serviceSet(params);

            let list = [];

            list = generateData(res?.data?.result, {
                page: query ? query?.pageNumber : page,
                pageSize: query?.pageSize || size,
            });
            setLoading(false);

            let d = {
                data: list,
                page: query ? query?.pageNumber : page,
                totalCount: res?.data?.count,
            };

            return d; //passed to MaterialTable
        } catch (error) {
            if (axios.isCancel(error)) {
                setLoading(true);
            } else {
                setLoading(false);
                return {
                    data: [],
                    page: query ? query?.pageNumber : page,
                    totalCount: 0,
                };
            }
        }
    };

    const exportServiceSet = async () => {
        setLoadingBtn(true);

        try {
            const result = await exportServiceSetApi();

            createToast('موفق', result?.data?.result || 'ارسال شد', 'success');
        } catch (error) {
        } finally {
            setLoadingBtn(false);
        }
    };

    //-- OTHER FUNCTIONS --//
    const onFiltersChange = (newFilters) => {
        setFilters(newFilters);
        setPage(0)
        setSize(10)
        setTimeout(() => {
            tableRef?.current?.onChangeTable(true);
        }, 100)
    };

    const confirmRequest = async () => {
        setLoadingBtnDialog(true);

        try {
            if (requestAction === 'publish') {
                await publishServiceSetApi(selectedRow.id);
            } else if (requestAction === 'unpublish') {
                await unPublishServiceSetApi(selectedRow.id);
            }
            setTimeout(() => {
                tableRef?.current?.onChangeTable();
            }, 100)
            createToast('موفق', 'درخواست شما با موفقیت ثبت شد', 'success');
        } catch (error) { }
        setLoadingBtnDialog(false);
        setSelectedRow({});
        setRequestAction('');
        setOpenDialog(false);
    };

    const requestPublish = (row) => {
        setSelectedRow(row);
        setRequestAction('publish');
        setDialogContent({
            title: 'درخواست انتشار',
            content: `از درخواست انتشار مجموعه سرویس "${row.name}" اطمینان  دارید؟`,
        });
        setOpenDialog(true);
    };

    const requestUnpublish = (row) => {
        setSelectedRow(row);
        setRequestAction('unpublish');
        setDialogContent({
            title: 'درخواست عدم انتشار',
            content: `از درخواست عدم انتشار مجموعه سرویس "${row.name}" اطمینان  دارید؟`,
        });
        setOpenDialog(true);
    };

    const ActionsBtn = () => {
        return (
            <>
                <ButtonLoading
                    type="submit"
                    variant="contained"
                    color="primary"
                    loading={loadingBtnDialog}
                    name="تایید"
                    onClick={confirmRequest}
                />

                <Button variant="contained" onClick={closeDialog}>
                    انصراف
                </Button>
            </>
        );
    };

    const hint =
        'در این بخش می‌توانید مجموعه سرویس‌های تعریف‌شده را ملاحظه و در صورت لزوم سرویس مورد نظر خود را ویرایش نمایید.';

    return (
        <PageContainer
            title="لیست مجموعه سرویس‌های من"
            description={hint}
            breadcrumbs={constBreadCrumbsTitle.SERVICES_SERVICESET}
            pageKey="myServiceSets"
            className={classes.root}
        >
            <SimpleDialog
                title={dialogContent.title}
                content={dialogContent.content}
                open={openDialog}
                onClose={closeDialog}
                actions={<ActionsBtn />}
            />
            <Grid item xs={12}>
                <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
                    {actionsList['subMyWebServiceListPage'] && (
                        <FilterButton
                            setOpenFilterDialog={setOpenFilterDialog}
                            filters={filters}
                        />
                    )}
                    {actionsList['exportSubMyWebServiceListPage'] && (
                        <ButtonLoading
                            color="primary"
                            siza="medium"
                            variant="contained"
                            disabled={loadingBtn}
                            loading={loadingBtn}
                            name="ارسال فایل خروجی"
                            onClick={exportServiceSet}
                        />
                    )}
                </Box>
                {actionsList['subMyWebServiceListPage'] && (
                    <Box>
                        <FilterPod
                            filters={filters}
                            onChange={onFiltersChange}
                            openFilterDialog={openFilterDialog}
                            setOpenFilterDialog={setOpenFilterDialog}
                            handleCloseFilterDialog={handleCloseFilterDialog}
                        />
                    </Box>
                )}
            </Grid>
            {actionsList['subMyWebServiceListPage'] && (
                <TableComponents
                    data={getServiceSetsList}
                    columns={columns(actionsList, navigate, requestPublish, requestUnpublish)}
                    ref={tableRef}
                    isLoading={loading}
                    onChange={(ps) => {
                        setPage(ps?.pageNumber)
                        setSize(ps?.pageSize)
                        return getServiceSetsList(ps)
                    }}

                />
            )}
        </PageContainer>
    );
}
export default ListServiceSets;
